<template>
  <div id="app">
    <div class="wrapper" style="height: auto; min-height: 100%;">
      <the-header></the-header>
      <div id="content-wrap" class="content-wrapper content-wrapper2">
    <!-- Content Header (Page header) -->
      <!-- <nav aria-label="breadcrumb" class="bread">
          <ol class="breadcrumb" style="margin-bottom: 0px;padding: 10px 80px;">
            <router-link  tag='li' :to='{name:"Dashboard"}' class="breadcrumb-item"><a href="#">Home</a></router-link>
            <li class="breadcrumb-item active c-white">{{head_name}}</li>
          </ol>
      </nav> -->
      <section class="contant">
        <transition name="page" mode="out-in">
          <router-view></router-view>
        </transition>
      </section>
      <!-- /.content -->
    </div>
    </div>
  </div>
</template>
<script>
// import TheHeader from '../TheHeader.vue'
import TheHeader from './TheHeader'

export default {
  name: 'TheContainer',
  data () {
    // this.url = this.$router.history.current.path
  },
  components: {
    TheHeader
  }
}
</script>
